'use client'
import React, {useEffect} from "react";
import Button from "@repo/ui/Button";
import {AlertTriangle} from "lucide-react";

export default function GlobalError({error, reset}: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-whiten p-6 dark:bg-boxdark-2">
            <div className="w-full max-w-md rounded-sm border border-stroke bg-white px-6 py-10 text-center shadow-default dark:border-strokedark dark:bg-boxdark sm:py-16">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-danger/10 text-danger">
                    <AlertTriangle className="h-6 w-6" aria-hidden="true"/>
                </span>
                <h2 className="mt-4 text-title-sm font-semibold text-black dark:text-white">Qualcosa è andato storto</h2>
                <p className="mt-2 text-sm text-body dark:text-bodydark">
                    Si è verificato un errore imprevisto. Riprova, oppure torna alla dashboard se il problema persiste.
                </p>
                <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
                    <Button variant="primary" onClick={() => reset()}>Riprova</Button>
                    <Button variant="secondary" link="/dashboard">Torna alla dashboard</Button>
                </div>
            </div>
        </div>
    );
}